import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Document } from '@contentful/rich-text-types';
import { SocialChallenge, SocialChallengeState } from '@ktypes/models';

interface TertiaryChallengeInfo {
  state?: string;
  separator?: string;
  statusIcon?: string;
  status?: number | string;
}

@Component({
  selector: 'kf-sc-social-challenge',
  templateUrl: './social-challenge.component.html',
  styleUrls: ['./social-challenge.component.scss'],
})
export class SocialChallengeComponent implements OnInit, OnChanges {
  @Input() challenge: SocialChallenge;

  challengeState = SocialChallengeState;
  challengeUrl: string;
  motivationMessage: Document;
  showExtraneous: boolean;
  showImage: boolean;
  showMotivationMessage: boolean;
  showProgress: boolean;
  tertiaryChallengeInfo: TertiaryChallengeInfo;

  ngOnInit() {
    this.challengeUrl = `/challenges/${this.challenge?.id}`;
  }

  ngOnChanges(/* changes: SimpleChanges */) {
    if (this.challenge) {
      this.tertiaryChallengeInfo = formatTertiaryInfo(this.challenge);
      this.showExtraneous = checkShowExtraneous(this.challenge);
      this.showImage = checkShowImage(this.challenge);
      this.showProgress = checkShowProgress(this.challenge);
      this.motivationMessage = this.challenge.individualGoalCompleted
        ? this.challenge.individual.completionMessage
        : this.challenge.individual.motivation;
      this.showMotivationMessage =
        this.motivationMessage &&
        (this.challenge.individualGoalCompleted || this.challenge.status.state !== SocialChallengeState.ended);
    }
  }
}

// export so it can be tested
export function formatTertiaryInfo(challenge: SocialChallenge): TertiaryChallengeInfo {
  if (!challenge) {
    return null;
  }
  const individualStatus = challenge.individual.status;
  const groupStatus = challenge.group.status;
  switch (challenge.status.state) {
    case SocialChallengeState.active:
      if (individualStatus.enrolled) {
        return {
          state: individualStatus.completedToday ? 'Completed Today!' : 'Not completed today',
        };
      }
      return {
        state: 'Not Joined',
        separator: ' • ',
        status: groupStatus.participating,
        statusIcon: '/assets/icons/users-group.svg',
      };
    case SocialChallengeState.upcoming:
      return { state: individualStatus.enrolled ? 'Joined' : 'Not Joined', separator: ' • ', status: 'Not Started' };
    case SocialChallengeState.ended:
      return { state: 'Ended' };
    default:
      return null;
  }
}

// export so it can be tested
export function checkShowExtraneous(challenge: SocialChallenge) {
  if (!challenge) {
    return false;
  }
  return !challenge.individual.status.completedToday && !challenge.individualGoalCompleted;
}

export function checkShowImage(challenge: SocialChallenge) {
  if (!challenge) {
    return false;
  }
  return (
    challenge.mediaObject?.url != null &&
    challenge.status.state !== SocialChallengeState.ended &&
    checkShowExtraneous(challenge)
  );
}

export function checkShowProgress(challenge: SocialChallenge) {
  if (!challenge) {
    return false;
  }
  return challenge.status.state !== SocialChallengeState.upcoming;
}
